import React, { useState, Suspense, useEffect } from "react";
import "./Subscription.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { Table } from "reactstrap";
import Loading from "../../components/Loading";
import LoggedHeader from "../../DefaultLayout/LoggedHeader";
import Footer from "../../DefaultLayout/Footer";
import DashboardNavbar from "../../DefaultLayout/DashboardNavbar.js";
import { connect, useSelector } from "react-redux";
import { getUserSubscription, runningSubscription } from "../../actions/subscription";
import moment from "moment";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { Box, Pagination } from "@mui/material";


const theme = createTheme({
  palette: {
    primary: {
      main: "#f5d792",
      darker: "#053e85",
    },
    neutral: {
      main: "#64748B",
      contrastText: "#fff",
    },
  },
});

const Subscription_history = (props) => {
  const { frontLabelsName } = props.label;

  const [page, setPage] = useState(1);
  const[loading,setLoading]=useState(true)
  const subscribeHistory = useSelector((state) => state.subscription);
  const { subscription,  } = subscribeHistory;

  const rows = subscription.docs;

  useEffect(() => {
    props.getUserSubscription(1,10).then(()=>{
      setLoading(false)
    });
  }, []);


  const handlePageChange = (e, p) => {
    setPage(p);
    setLoading(true)
    props.getUserSubscription(p,10).then(()=>{
      setLoading(false)
    });;
  };

 

  return (
    <React.Fragment>
      <Suspense fallback={<Loading />}>
        <LoggedHeader />
        {/* <NavbarSection /> */}
        <DashboardNavbar/>
      </Suspense>
      <div className="container">
        <div className="row">
          <div className="col-lg-12 col-md-12">
            <div className="sub-his p-3">
              <div className="sub-his-desc">
                <h2>
                  {frontLabelsName
                    ? frontLabelsName.filter((e) => e.key == "lbl_subscription_history")
                      .length > 0
                      ? frontLabelsName.filter(
                        (e) => e.key == "lbl_subscription_history"
                      )[0]["value"] || "lbl_subscription_history"
                      : "lbl_subscription_history"
                    : "lbl_subscription_history"}
                </h2>
              </div>
              <div className="his-dsc">
                <Table striped bordered responsive>
                  <thead>
                    <tr className="bg-dark text-white">
                      <th>
                        {frontLabelsName
                          ? frontLabelsName.filter((e) => e.key == "lbl_plan_date")
                            .length > 0
                            ? frontLabelsName.filter(
                              (e) => e.key == "lbl_plan_date"
                            )[0]["value"] || "lbl_plan_date"
                            : "lbl_plan_date"
                          : "lbl_plan_date"}
                      </th>
                      <th>
                        {frontLabelsName
                          ? frontLabelsName.filter((e) => e.key == "lbl_subscription_history")
                            .length > 0
                            ? frontLabelsName.filter(
                              (e) => e.key == "lbl_subscription_date"
                            )[0]["value"] || "lbl_subscription_date"
                            : "lbl_subscription_date"
                          : "lbl_subscription_date"}
                      </th>
                      <th>
                        {frontLabelsName
                          ? frontLabelsName.filter((e) => e.key == "lbl_subscription_history")
                            .length > 0
                            ? frontLabelsName.filter(
                              (e) => e.key == "lbl_active_date"
                            )[0]["value"] || "lbl_active_date"
                            : "lbl_active_date"
                          : "lbl_active_date"}
                      </th>
                      <th>
                        {frontLabelsName
                          ? frontLabelsName.filter((e) => e.key == "lbl_gross_amount")
                            .length > 0
                            ? frontLabelsName.filter(
                              (e) => e.key == "lbl_gross_amount"
                            )[0]["value"] || "lbl_gross_amount"
                            : "lbl_gross_amount"
                          : "lbl_gross_amount"}
                      </th>
                      <th>
                        {frontLabelsName
                          ? frontLabelsName.filter((e) => e.key == "lbl_status")
                            .length > 0
                            ? frontLabelsName.filter(
                              (e) => e.key == "lbl_status"
                            )[0]["value"] || "lbl_status"
                            : "lbl_status"
                          : "lbl_status"}
                      </th>
                   
                    </tr>
                  </thead>
                  <tbody className="text-center">
                    {!loading &&
                      rows.length > 0 &&
                      rows.map((subHistory, index) => {
                        return (
                          <tr key={index}>
                            <td>{subHistory?.planData?.name}</td>
                            <td>
                              {moment(subHistory?.purchase_date).format(
                                "DD/MM/YYYY"
                              )}
                            </td>
                            <td>
                              {moment(subHistory?.purchase_date).format(
                                "DD/MM/YYYY"
                              )}{" "}
                             {frontLabelsName
                          ? frontLabelsName.filter((e) => e.key == "lbl_to")
                            .length > 0
                            ? frontLabelsName.filter(
                              (e) => e.key == "lbl_to"
                            )[0]["value"] || "lbl_to"
                            : "lbl_to"
                          : "lbl_to"}{" "}
                              {moment(subHistory?.expiry_date).format(
                                "DD/MM/YYYY"
                              )}
                            </td>
                            <td>kr. {subHistory?.planData?.amount}</td>
                            <td>
                              {subHistory?.status == 0 ?frontLabelsName
                          ? frontLabelsName.filter((e) => e.key == "lbl_inactive")
                            .length > 0
                            ? frontLabelsName.filter(
                              (e) => e.key == "lbl_inactive"
                            )[0]["value"] || "lbl_inactive"
                            : "lbl_inactive"
                          : "lbl_inactive" : frontLabelsName
                          ? frontLabelsName.filter((e) => e.key == "lbl_active")
                            .length > 0
                            ? frontLabelsName.filter(
                              (e) => e.key == "lbl_active"
                            )[0]["value"] || "lbl_active"
                            : "lbl_active"
                          : "lbl_active"}
                            </td>
                            
                          </tr>
                        );
                      })}
                    {loading && <Loading height={50} />}
                    {!loading && rows.length === 0 && (
                      <tr>
                        <td colspan="6">
                          <div className="text-center">

                            {frontLabelsName
                              ? frontLabelsName.filter((e) => e.key == "lbl_no_subs_history")
                                .length > 0
                                ? frontLabelsName.filter(
                                  (e) => e.key == "lbl_no_subs_history"
                                )[0]["value"] || "lbl_no_subs_history"
                                : "lbl_no_subs_history"
                              : "lbl_no_subs_history"}
                          </div>
                        </td>
                      </tr>
                    )}
                  </tbody>
                </Table>
              </div>
            </div>
            <Box
              display="flex"
              justifyContent="center"
              alignItems="center"
              mt={0}
              mb={4}
            >
              <ThemeProvider theme={theme}>
                {rows.length > 0 && !loading && (
                  <Pagination
                    count={subscription.totalPages}
                    color="primary"
                    page={page}
                    onChange={handlePageChange}
                    shape="rounded"
                    sx={{ textAlign: "center" }}
                  />
                )}
              </ThemeProvider>
            </Box>
          </div>
        </div>
      </div>
      <Suspense fallback={<Loading />}>
        <Footer />
      </Suspense>
    </React.Fragment>
  );
};

const mapStateToProps = (state) => ({
  label: state.language
});

export default connect(mapStateToProps, { getUserSubscription, runningSubscription })(Subscription_history);
